jQuery(document).ready(function () {

    let item = $('#not-from-estate');
    
    if(item.length) {
        
        let offsetCookie = parseInt(item.data('offset')), slug = item.data('slug'), id = '#' + slug;

        for(i = 0, offset = (offsetCookie/10); i < offset; ++i)
            $( ".ef-rm" ).trigger( "click" );   

        waitForEl(id, function () {
            setTimeout(function(){ 
                $('html, body').animate({
                scrollTop: $(id).offset().top - 150
            }, 2000);
            }, offsetCookie * 80);                                        
        });  
    }
});